import { useEffect } from 'react';
import { useStateStore } from '../stores/useStateStore';

export const useInitTTS = () => {
  const initTTS = useStateStore((state) => state.initTTS);

  useEffect(() => {
    initTTS();
  }, [initTTS]);
};
